<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <h2 class="mb-4">Data Analysis - Neon</h2>

      <p class="mb-3">
        Report the wavelengths of 5 spectral lines you observed in the
        <b>neon</b> spectrum in the table below. You should have observed more than 5 peaks, but
        just choose 5 to include here. Then, use the formula
        <stemble-latex content="$\displaystyle{E=hc/\lambda}$" /> to calculate the photon energy for
        the transition.
      </p>

      <p class="mb-0">
        <b>Notes</b>
      </p>

      <ul class="mb-3">
        <li>
          Photon energies should be expressed using scientific notation. To express a number like
          <stemble-latex content="$1.23 \times 10^{-10}$" /> in scientific notation, write 1.23e-10
        </li>
        <li>The speed of light, <stemble-latex content="$c=2.998\times 10^8~\text{m/s}$" /></li>
        <li>
          Planck's constant,
          <stemble-latex content="$h=6.626\times 10^{-34}~\text{J}\cdot\text{s}$" />
        </li>
        <li>
          Reminder: Because the units of c are in m/s, be sure to convert your wavelength to m
          before calculating the energy so your units will cancel.
        </li>
      </ul>

      <v-simple-table style="max-width: 493px">
        <thead>
          <tr>
            <td style="font-weight: bold; text-align: center">
              Wavelength, <stemble-latex content="$\lambda$" /> (nm)
            </td>
            <td style="font-weight: bold; text-align: center">Photon Energy (J)</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="spectralLine in spectralLines" :key="spectralLine.wavelength">
            <td class="py-2 my-2">
              <calculation-input
                v-model="inputs[spectralLine.wavelength]"
                class="centered-input"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
            <td class="py-2 my-2">
              <calculation-input
                v-model="inputs[spectralLine.energy]"
                class="centered-input"
                :show-scientific-notation="false"
                :disabled="!allowEditing"
              />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import ChemicalSymbolInput from '@/tasks/components/inputs/ChemicalSymbolInput.vue';
import NumberValue from '@/tasks/components/NumberValue.vue';
import LatexNumber from '@/tasks/components/displayers/LatexNumber.vue';
import STextarea from '@/common/components/STextareaShort.vue';

export default {
  name: 'OleMiss_AtomicEmission_NeonResults',
  components: {
    STextarea,
    LatexNumber,
    NumberValue,
    ChemicalSymbolInput,
    ChemicalNotationInput,
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        wavelength1: null,
        energy1: null,

        wavelength2: null,
        energy2: null,

        wavelength3: null,
        energy3: null,

        wavelength4: null,
        energy4: null,

        wavelength5: null,
        energy5: null,
      },
      spectralLines: [
        {wavelength: 'wavelength1', energy: 'energy1'},
        {wavelength: 'wavelength2', energy: 'energy2'},
        {wavelength: 'wavelength3', energy: 'energy3'},
        {wavelength: 'wavelength4', energy: 'energy4'},
        {wavelength: 'wavelength5', energy: 'energy5'},
      ],
    };
  },
};
</script>
<style scoped></style>
